export const encodeProductNameForUriOld = (
  productName?: string | null
): string =>
  encodeURIComponent(
    (productName ?? 'product-name').toLowerCase().replace(/[',]/g, '')
  )
    .replace(/%20/g, '-') // Space
    .replace(/%2F/g, '-') // Forward slash
    .replace(/\./g, '-')
    .replace(/!/g, '');
